"use client";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import type { ApiResponse, PaginatedResult } from "@/lib/fetch";
import type { Consultant, Expertise } from "@/types/consulting";
import FilterSelect from "../ui/filter-select";
import ExpertCard from "./expert-card";

const ExpertList = ({
  consultingId,
  expertises,
}: {
  expertises: Expertise[];
  consultingId: string;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const expertiseId = searchParams.get("expertise");
  const expertise = expertises.find((item) => item.id === expertiseId);
  const cityId = searchParams.get("city");
  const city = expertise?.cities.find((item) => item.id === cityId);

  // biome-ignore lint/correctness/useHookAtTopLevel: <explanation>
  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);

      return params.toString();
    },
    [searchParams],
  );
  const { data, isLoading } = useQuery({
    queryFn: async () => {
      const url = `/api/consulting/${consultingId}/consultants?ExpertiseId=${expertiseId}&CityId=${cityId}`;
      const response = await axios
        .get<ApiResponse<PaginatedResult<Consultant>>>(url)
        .then((res) => res.data);
      if (!response.isSuccess) {
        return [];
      }
      return response.result.data;
    },
    queryKey: ["experts", consultingId, expertiseId, cityId],
  });
  if (isLoading) {
    return "loading...";
  }

  return (
    <div className="flex flex-col justify-start items-start gap-4">
      <div className="flex flex-col md:flex-row gap-4">
        <FilterSelect
          label="Uzmanlık"
          onChange={(e: string) => {
            router.push(`${pathname}?${createQueryString("expertise", e)}`);
          }}
          options={expertises}
          value={expertise?.id}
        />
        <FilterSelect
          label="Şehir"
          onChange={(e) => {
            router.push(`${pathname}?${createQueryString("city", e)}`);
          }}
          options={expertise?.cities || []}
          value={city?.id}
        />
      </div>
      <div className="flex flex-row gap-2 justify-start items-start w-full flex-wrap">
        {data?.map((expert) => (
          <ExpertCard expert={expert} key={expert.id} />
        ))}
      </div>
    </div>
  );
};

export default ExpertList;
